


















































































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import ContractCancellationProvider from "@/components/app/global/contracts/contractCancellationProvider";

// Data
import { ConfirmModalModes } from "@/data/enums";

@Component({
  components: {
    "contract-cancellation-options": () =>
      import(
        "@/components/app/global/contracts/contractCancellationOptions.vue"
      ),
    "contract-cancellation-refund-options": () =>
      import(
        "@/components/app/global/contracts/contractCancellationRefundOptions.vue"
      ),
    "contract-money-back-period": () =>
      import("@/components/app/global/contracts/contractMoneyBackPeriod.vue"),
    "cprod-well-link": () =>
      import(`@/components/app/global/contractProducts/cProdWellLink.vue`)
  }
})
export default class AdminContractCancellationModal extends Mixins(
  ContractCancellationProvider,
  HasValidation
) {
  public get reason() {
    return this.$_.get(this.cancellationRequest, "reason", "")
      .trim()
      .replace(/[^a-zA-Z\d]$/, "");
  }

  public async validateBeforeSubmit() {
    if (this.isSubmitDisabled) return;

    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      if (
        this.immediatelyWithFullRefund &&
        this.isProductCancellation &&
        !(await this.confirmCancel())
      )
        return;

      this.isProcessing = true;
      await this.submit();
      this.$emit("close");
      this.$emit("contract-updated");
      this.$buefy.toast.open({
        message: this.$t("_.object_successfully_updated", {
          object: this.$t("_.contract")
        }) as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public async confirmCancel() {
    return new Promise(resolve => {
      this.$store.dispatch("ui/open/confirmModal", {
        config: {
          props: {
            autoClose: true,
            mode: ConfirmModalModes.BUTTON,
            title: this.$t("_action.confirm_cancellation"),
            confirmButtonText: this.$t("_action.confirm"),
            message: this.$t("_sentence.cprod.full_refund_cancel_confirmation")
          },
          events: {
            confirmed: () => {
              resolve(true);
            },
            close: () => {
              resolve(false);
            }
          }
        }
      });
    });
  }

  public submit() {
    if (this.isCancellationRequest) return this.submitCancellationRequest();
    return this.$_.get(
      this.$_.find(this.cancelOptions, ["id", this.cancelOption]),
      "onSubmit",
      () => Promise.resolve()
    )();
  }

  public get isSubmitDisabled() {
    if (this.isProcessing) return true;
    if (this.hasErrors) return true;
    if (this.showRefundOptions && this.refundOption === null) return true;
    if (this.isCancellationRequest) return this.$_.isNull(this.approveRequest);
    return this.$_.isNull(this.cancelOption);
  }
}
